
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import ProviderDashboard from '@/components/dashboard/ProviderDashboard';
import CaseManagerDashboard from '@/components/dashboard/CaseManagerDashboard';
import AdminDashboard from '@/components/dashboard/AdminDashboard';

const Dashboard = () => {
  const { user, profile } = useAuth();

  if (!user || !profile) return null;

  switch (profile.role) {
    case 'provider':
    case 'hss_provider':
      return <ProviderDashboard />;
    case 'case_manager':
    case 'social_worker':
    case 'discharge_planner':
    case 'housing_stabilization_worker':
      return <CaseManagerDashboard />;
    case 'admin':
      return <AdminDashboard />;
    default:
      return <div>Invalid user role</div>;
  }
};

export default Dashboard;
